import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CommonEmitter {
    type: string;
    data: string;
  }

let commonEmitter:CommonEmitter={ type: '', data: '' };
const commonEmitterSlice = createSlice({
  name: "commonEmitterObject",
  initialState: commonEmitter,
  reducers: {
    setCommonEmitter: (
      _,
      action: PayloadAction<CommonEmitter>
    ) => {
     return action.payload;
    },


  },
});


export default commonEmitterSlice.reducer;
export const { setCommonEmitter} = commonEmitterSlice.actions;